
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import BarcodeOrderModule from "@/store/modules/barcodeSystem/barcodeOrder";
import InventoryModule from "@/store/modules/barcodeSystem/inventory";
import { PalletListItem } from "@/models/api/barcodeSystem/inventory/pallets";
import { formatDateWithTime, formatBool } from "@/utils";
import permissions from "@/security/permissions";

const barcodeOrderModuleState = getModule(BarcodeOrderModule);
const inventoryModuleState = getModule(InventoryModule);

@Component
export default class BarcodeOrderPalletTable extends Vue {
  @Prop({ default: false })
  loading: boolean;

  get pallets(): Array<PalletListItem> {
    return barcodeOrderModuleState.currentBarcodeOrderPallets;
  }

  get selectedItemCount(): number {
    return barcodeOrderModuleState.getSelectedBarcodeOrderPalletCount;
  }

  get selectedItems(): Array<any> {
    return barcodeOrderModuleState.getSelectedBarcodeOrderPallets;
  }

  get totalItems() {
    if (barcodeOrderModuleState.currentBarcodeOrderPallets) {
      return barcodeOrderModuleState.currentBarcodeOrderPallets.length
    } else {
      return 0;
    }
  }

  getComponentData(rowData) {
    return {
      on: {
        dblclick: () => this.onDoubleClicked(rowData)
      }
    };
  }

  formatDateWithTime(val)
  {
    return formatDateWithTime(val)
  }

  formatBool(val)
  {
    return formatBool(val);
  }

  onDoubleClicked(data) {
    if(this.hasPermission(permissions.barcodeSystem.inventory.view))
      inventoryModuleState.viewPalletShortcutAction({selectedItems: [data]});
  }

  onRowClick(data) {
    barcodeOrderModuleState.switchBarcodeOrderPalletSelectionStatus(data.id);
  }

  unselectAll() {
    let items = this.selectedItems;

    items.forEach(item => {
      barcodeOrderModuleState.switchBarcodeOrderPalletSelectionStatus(item.id);
    });
  }
}
